<template>
  <div>
    <section class="section">
      <div class="container">
        <h1 class="title">We are reviewing our City Plan 2030.</h1>

        <h2 class="title">We have commenced the process of reviewing our City Plan and are eager to hear from you. Our
          City Plan sets Council’s long term strategic direction for the City, looking towards 2030.
          The City Plan is an articulation of our purpose as a Council. It captures and presents the aspirations of the
          people of City, as well as our Elected Members and staff. It acts as a guide for how we think and make
          decisions.</h2>
        <br />
        <h2 class="subtitle">It’s vital that we get input from staff about what we believe is important for the future
          of our City.</h2>
        <blockquote>To read more about our City Plan, and the documents that support it, visit <a
            href="https://www.cityofpae.sa.gov.au/page.aspx?u=2554">https://www.cityofpae.sa.gov.au/page.aspx?u=2554</a><br />
          <template v-if="staff == 'staff'"><label>Some key data about our City is also available. <a target="_blank"
                href="/documents/pae-at-a-glance.pdf">pae-at-a-glance.pdf</a></label><br /></template>
          We are asking all staff to reflect on our last three years of work, and let us know if the
          projects that we have delivered have led to improvements in our key areas of Economy, Community, Environment,
          Placemaking and Leadership.
        </blockquote>
        <br />
        <p>Use the thumb icons to <strong>vote yes or no</strong> and let us know if you have seen improvements.</p>
        <p>We also want to hear about what work you are proud of and what you love about our City.</p>
        <p>Then we ask you to imagine what the PAE of the future looks like, and ask what we need to do to make our
          vision a reality.</p>
        <p>Complete the survey by <strong>15 November 2019</strong> to be part of setting our direction for the next
          three years.
        </p>
      </div>
    </section>

    <!-- <section class="section threeyears">
      <div class="container">
        <h1 class="title is-2">The last 3 years</h1>
      </div>
    </section>-->

    <template v-for="section in sections">
      <section class="section" :class="section.name.toLowerCase()" :key="section.id">
        <div class="iconSection">
          <h1 class="title is-2" style="display:none;">{{ section.name }}</h1>
          <img class="sectionSymbol" :src="'/images/CityPlan/cityplan-'+section.name.toLowerCase()+'.png'" />
        </div>

        <div class="survey">
          <form @submit.prevent="submit">
            <input type="hidden" name="_token" :value="csrf" />
            <input type="hidden" name="section" :value="section.name" />
            <div class="form-group">
              <div class="icons">
                <div class="bg good" :class="{ 'selected' : surveyResults[section.name] }">
                  <i class="fas fa-thumbs-up good" @click="toggleSelection(section.name, true)"></i>
                </div>
                <div class="bg bad" :class="{ 'selected' : surveyResults[section.name]===false }">
                  <i class="fas fa-thumbs-down bad" @click="toggleSelection(section.name, false)"></i>
                </div>
              </div>
              <h4 class="title is-4">
                Did
                <template v-if="section.name.toLowerCase() == 'placemaking'">the places in our community</template>
                <template v-else-if="section.name.toLowerCase() == 'leadership'">our Council</template>
                <template v-else>our {{ section.name.toLowerCase() }}</template>
                improve in the last 3 years?
              </h4>
            </div>
          </form>
        </div>

        <div :class="section.name+'Content'">
          <div class="columns is-multiline is-mobile is-gapless">
            <div class="column is-one-third-desktop is-half-tablet is-full-mobile"
              v-for="(card, index) in items[section.name]['images']" :key="index">
              <card :info="card" :section="section.name.toLowerCase()"></card>
            </div>
          </div>
        </div>

        <div style="display:none">
          <div :class="section.name+'Content'" class="stats columns is-multiline is-mobile is-gapless">
            <div class="column is-vertical-center" v-for="(stat, index) in items[section.name]['stats']" :key="index">
              <div class="circle" :class="section.name" v-for="data in stat.data" :key="data.index">
                <label class="year">{{data.year }}</label>
                <br />
                <label class="value">{{data.value}}</label>
              </div>
              <br />
              <span class="title">{{ stat.title }}</span>
              <br />
              {{ stat.summary }}
            </div>
          </div>
        </div>

        <div style="display:none;" class=" table-container Box" :class="section.name"
          v-if="items[section.name]['Info']">
          <table class="table is-narrow is-fullwidth">
            <thead>
              <tr>
                <th>What it looks like?</th>
                <th>Indicator</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="info in items[section.name]['Info']">
                <td>{{ info.LooksLike }}</td>
                <td>{{ info.Indicator }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </section>

    </template>

    <section style="margin-bottom: 3em;" v-if="staff == 'staff'">
      <div class="container">
        <h2 class="title is-2" style="background: #333; color: #fff; display: inline-block; padding: .5rem;">Tell us
          more..
        </h2>
        <template v-for="(question, i) in surveyResults.Questions">
          <div style="margin-bottom: 1em;">
            <p><strong>{{ question.title }}</strong></p>
            <template v-if="surveySubmitted == false">
              <textarea class="textarea" rows="2" placeholder="Please tell us what you think"
                v-model="surveyResults.Questions[i].value"></textarea>
            </template>
            <template v-else>
              <p v-if="surveyResults.Questions[i].value">{{ surveyResults.Questions[i].value }}</p>
              <p v-else>-</p>
            </template>
          </div>
        </template>
      </div>
    </section>

    <div style="padding: 3em;" v-if="surveySubmitted==false">
      <a class="button is-large is-fullwidth is-primary" @click="submit">Submit</a>
    </div>
    <div v-else style="text-align:center; padding: 4em; border:1px solid #333;">
      <h2 class="title is-2">Thankyou for your submission.</h2>
    </div>
  </div>
</template>
<script>
  import card from "./CityPlanCard";
import VueCookies from "vue-cookies";
var Vue = require("vue");
Vue.use(require("vue-cookies"));

// set default config
VueCookies.config("7d");

export default {
  components: {
    card
  },
  props: {
      staff: "",
  },
  data() {
    return {
      csrf: "",
      selectedCard: -1,

      sections: [
        { name: "Economy" },
        { name: "Community" },
        { name: "Environment" },
        { name: "Placemaking" },
        { name: "Leadership" }
      ],

      items: {
        Economy: {
          Info: [
            {
              LooksLike: "Prosperous",
              Indicator: "Gross regional product"
            },
            {
              LooksLike: "Connected",
              Indicator: "Proportion who feel that they can easily access information and organisations"
            },
            {
              LooksLike: "Growing",
              Indicator: "Number of local jobs"
            }
          ],
          images: [
            {
              Title: "St Jerome's Laneway Festival",
              Summary:
                "This annual event attracts thousands of visitors and music lovers to our City",
              Image: "1Laneway.jpg"
            },
            {
              Title: "Economic Development Strategy",
              Summary:
                "Our newly formed Economic Development Team have delivered our first strategy focusing on positive economic growth  ",
              Image: "1EconomicDevelopment.jpg"
            },
            {
              Title: "Civic Relationship- Cherbourg",
              Summary:
                "A landmark letter of intent was signed to strengthen economic ties between our two Port cities",
              Image: "1Cherbourg.jpg"
            },
            {
              Title: "Port transformation ",
              Summary:
                "We’re supporting residential opportunities in the Port with investments in Dock 1, Port Approach, North West and Fletcher’s Slip ",
              Image: "1PortTransformation.png"
            },
            {
              Title: "Tour Down Under",
              Summary:
                "This hugely popular racing event saw people from the all over the world tuning in to see our City on show",
              Image: "1TourDownUnder.jpg"
            },
            {
              Title: "Business Support",
              Summary:
                "Our economic investment has  provided direct benefits to the local business community which includes employee growth by 18% and annual revenue increases of 20%",
              Image: "1BusinessBriefing.jpg"
            }
          ]
        },
        Community: {
          Info: [
            {
              LooksLike: "Healthy",
              Indicator: "Proportion who say they are healthy"
            },
            {
              LooksLike: "Inclusive",
              Indicator: "Proportion who feel a part of their local community"
            },
            {
              LooksLike: "Cohesive",
              Indicator: "Proportion who say they feel safe in their neighbourhood or community"
            }
          ],          
          images: [
            {
              Title: "Beach Access Mats",
              Summary:
                "We trialled beach access mats at several locations along the coast to make the beach more accessible ",
              Image: "2Beach.jpg"
            },
            {
              Title: "Welcoming Cities",
              Summary:
                "The City of PAE was the first Council in SA to join the Welcoming Cities Network to demonstrate our support for new arrivals and migrants",
              Image: "2Welcoming.jpg"
            },
            {
              Title: "Community Foodies",
              Summary:
                "Our trained community Foodies help us encourage others to eat well and live a healthy lifestyle",
              Image: "2Foodies.jpg"
            },
            {
              Title: "Parks Library",
              Summary:
                "The innovative and dynamic Parks Library was opened in October 2018",
              Image: "2ParksLibrary.jpg"
            },
            {
              Title: "Sport Development Plan",
              Summary:
                "Our Sports Development Plan will help us ensure everyone can access top quality, local sporting opportunities",
              Image: "2Sports.jpg"
            },
            {
              Title: "Community Emergency Management Plan ",
              Summary:
                "This plan is designed to increase the community awareness, understanding and resilience in the event of an emergency incident",
              Image: "2CEMP.jpg"
            }
          ]
        },
        Environment: {
          Info: [
            {
              LooksLike: "Distinctive",
              Indicator: "Proportion who say the city’s heritage is effectively managed"
            },
            {
              LooksLike: "Adaptable",
              Indicator: "City adaptability score"
            },
            {
              LooksLike: "Sustainable",
              Indicator: "Proportion who say the city’s natural environment is effectively protected"
            }
          ],     
          images: [
            {
              Title: "Environment and Waste Strategies",
              Summary:
                "Through the review and implementation of high level plans, were showing our ongoing commitment to caring for our environment",
              Image: "3EwasteCage.jpg"
            },
            {
              Title: "Stormwater Management",
              Summary:
                "These plans allow us to identify and understand flood risks areas, and prioritise our work in stormwater management and flood mitigation",
              Image: "3Stormwater.jpg"
            },
            {
              Title: "Maritime Precinct",
              Summary:
                "We're working with the State Government to preserve and develop our unique maritime heritage ",
              Image: "3MaritimePrecinct.jpg"
            },
            {
              Title: "Local Area Traffic Management",
              Summary:
                "Traffic Management improvements are happening from Rosewater and Ottoway  in the West to Northfield and Blair Athol in the East",
              Image: "3Traffic.jpg"
            },
            {
              Title: "Animal Management",
              Summary:
                "A review of our Animal Management Plan has lead to some new approaches for making our public spaces pet friendly ",
              Image: "3Animal.jpg"
            },
            {
              Title: "Community Participation",
              Summary:
                "We work with schools and community groups on coastal care programs, and more than 400 people helping with planting for Arbor Day",
              Image: "3ArborDay.jpg"
            }
          ]
        },
        Placemaking: {
          Info: [
            {
              LooksLike: "Belonging",
              Indicator: "City net promoter score"
            },
            {
              LooksLike: "Accessible",
              Indicator: "Proportion who say they can easily access places and services across the city"
            },
            {
              LooksLike: "Creative",
              Indicator: "Proportion who feel they had an opportunity to participate/experience local arts and cultural activities"
            }
          ],     
          images: [
            {
              Title: "Open Spaces",
              Summary:
                "We've delivered major open space upgrades at Roy Marten Dog Park, Taperoo Reserve, Hanson Reserve, Durant Reserve, Brian Reserve and TK Shutter Reserve",
              Image: "4RoyMarten.jpg"
            },
            {
              Title: "Eastern Events",
              Summary:
                "Our Summer Movie series and the Tasting Australia Food 5085 event have activated community spaces on the Eastern side of PAE",
              Image: "4Food.jpg"
            },
            {
              Title: "Beach Netball",
              Summary:
                "Australia’s largest Beach Netball Festival came to Semaphore for the first time in March 2017",
              Image: "4BeachNetball.jpg"
            },
            {
              Title: "Port Fringe",
              Summary:
                "All the weird and wonderful elements of the Fringe Festival comes to the Port for our annual Fringe Party",
              Image: "4PortFringe.jpg"
            },
            {
              Title: "Wonderwalls",
              Summary:
                "Local, national and international artists have completed some amazing murals in the Port during this national Festival",
              Image: "4Wonderwalls.jpg"
            },
            {
              Title: "The Lights",
              Summary:
                "We're working in partnership with the State Government to deliver an exciting multi-purpose community recreational facility in the new suburb of Lightsview",
              Image: "4TheLights.jpg"
            }
          ],
          stats: [
            {
              title: "Healthy Scorecard",
              summary: "f hkdjhfkjdh fkjdh fkjd kjfh kjdhfkjd hfjkd",
              data: [
                { year: 2017, value: 25 },
                { year: 2018, value: 19 },
                { year: 2019, value: 3.8 }
              ]
            },
            {
              title: "Part of Comm Scorecard",
              summary: "f hkdjhfkjdh fkjdh fkjd kjfh kjdhfkjd hfjkd",
              data: [{ year: 2017, value: 25 }, { year: 2018, value: 19 }]
            }
          ]
        },
        Leadership: {
          Info: [
            {
              LooksLike: "Strategic",
              Indicator: "Proportion who say council delivers value for the rate dollar"
            },
            {
              LooksLike: "Accountable",
              Indicator: "Proportion who are satisfied with council services"
            },
            {
              LooksLike: "Engaged",
              Indicator: "Proportion who say council is engaging with the people and relevant organisations and businesses"
            }
          ],     
          images: [
            {
              Title: "Community Survey",
              Summary:
                "We've increased participation in community engagement with our annual community Survey now translated into seven languages",
              Image: "5Survey.jpg"
            },
            {
              Title: "Procurement",
              Summary:
                "Our procurement project has helped us ensure value for money in the acquisition of goods and services",
              Image: "5Procurement.jpg"
            },
            {
              Title: "Project Management",
              Summary:
                "An online Capital Works Map shows the real time status of projects all across the City",
              Image: "5ProjectMgmt.png"
            },
            {
              Title: "Customer Experience program",
              Summary:
                "Right throughout the organisation, our staff have committed to providing outstanding excellent customer services",
              Image: "5Customer.jpg"
            },
            {
              Title: "Budget efficiency",
              Summary:
                "We've reviewed the way we plan and budget, resulting increased efficiency which helps us ensure savings ",
              Image: "5Budget.jpg"
            },
            {
              Title: "Culture",
              Summary:
                "Our second survey has shown there are ongoing improvements in our workplace culture, supported by our participation in the Human Synergistic Program",
              Image: "5Mentoring.jpg"
            }
          ],
          stats: [
            {
              title: "City Net Promoter Score",
              summary: "",
              data: [
                { year: 2017, value: 25 },
                { year: 2018, value: 19 },
                { year: 2019, value: 3.8 }
              ]
            },
            {
              title:
                "Proportion who say they can easily access places and services across the city",
              summary: "",
              data: [{ year: 2017, value: 25 }, { year: 2018, value: 19 }]
            },
            {
              title:
                "Healthy who say they can easily access places and services across the city",
              summary: "",
              data: [{ year: 2017, value: 20 }]
            }
          ]
        }
      },

      surveyCompleted: {
        economy: false,
        community: false,
        environment: false,
        placemaking: false,
        leadership: false
      },

      surveySubmitted: false,

      surveyResults: {
        Economy: null,
        Community: null,
        Environment: null,
        Placemaking: null,
        Leadership: null,
        Questions: [
          {
            title: "What have we achieved/accomplished as a Department, Council or City in the past 3 years that we are proud of?",
            value: ""
          },
          {
            title: "What is it about PAE that is special or unique?",
            value: ""
          },
          {
            title: "What are the places, people and groups that you love about PAE?",
            value: ""
          },
          {
            title: "What do you think PAE should be known for?",
            value: ""
          },
          {
            title: "What will our City look like in 2030?",
            value: ""
          },
          {
            title: "What do we need to do now to make that 2030 vision happen?",
            value: ""
          }
        ]
      }
    };
  },

  watch: {
    value: function() {}
  },

  methods: {
    submit: function() {
      let self = this;
      let params = Object.assign(
        {},
        { Survey: JSON.stringify(self.surveyResults) },
        { SurveyTitle: "City Plan Review 2019" }
      );

      axios
        .post("/cityplan/review", params)
        .then(function() {
          self.surveyCompleted.economy = true;
          self.surveyCompleted.community = true;
          self.surveyCompleted.environment = true;
          self.surveyCompleted.placemaking = true;
          self.surveyCompleted.leadership = true;
          self.surveyCompleted.questions = true;
          self.surveySubmitted = true;

          self.$cookies.set("survey_cityplan", self.surveyResults);
        })
        .catch(function(error) {
          console.log(error);
        });

      return;
    },

    toggleSelection(section, value) {
      if (this.surveySubmitted == false) {
        this.surveyResults[section] = value;
      }
    }
  },

  mounted() {
    this.csrf = window.laravel.csrfToken;
  },

  created() {
    if (this.$cookies.get("survey_cityplan")) {
      this.surveySubmitted = true;
      this.surveyResults = this.$cookies.get("survey_cityplan");
    }
  }
};
</script>
<style lang="scss" scoped>
  .today {
    background: #dee;
  }

  blockquote {
    border-left-color: #333;
  }

  .economyContent {
    padding-top: 3em;
  }

  .economy *,
  .community *,
  .environment *,
  .placemaking *,
  .leadership * {
    color: #333;
  }

  // .economy {
  //   background: #3b61da;
  // }
  // .community {
  //   background: #e27933;
  // }
  // .environment {
  //   background: #29a358;
  // }
  // .placemaking {
  //   background: #f7eac8;
  // }
  // .leadership {
  //   background: #794fa0;
  // }

  .iconSection {
    display: inline-block;
    width: 30%;
    vertical-align: middle;
  }

  .survey {
    display: inline-block;
    width: 65%;
    text-align: right;
    vertical-align: middle;

    .icons {
      text-align: right;
      display: inline-flex;

      .bg {
        margin: 2px;
        margin-bottom: 1em;
        border-radius: 50px;
        background: #eee;

        &.good.selected {
          background: green;
        }

        &.bad.selected {
          background: red;
        }

        i.far,
        i.fas {
          font-size: 2em;
          padding: 0.5em;
          color: white;
          position: relative;

          &.good {
            -webkit-transition: -webkit-transform 0.5s ease-in-out;
            transition: transform 0.3s ease-in-out;

            &:hover {
              -webkit-transform: rotate(-30deg);
              transform: rotate(-30deg);
            }

            &:active {
              transition: transform 0.1s ease-in-out;
              -webkit-transform: rotate(30deg);
              transform: rotate(30deg);
            }
          }

          &.bad {
            -webkit-transition: -webkit-transform 1.8s ease-in-out;
            transition: transform 1.8s ease-in-out;
            top: 3px;

            &:hover {
              top: 8px;
            }

            &:active {
              top: 12px;
            }
          }
        }
      }
    }
  }

  .sectionSymbol {
    max-height: 12em;
  }

  .iconLinks {
    line-height: 1.2em;
  }

  .iconLinks i {
    margin-bottom: 0.2em;
  }

  ul.serviceFilter li {
    background: #666;
    color: #888;
  }

  ul.serviceFilter li.active {
    background: #17c4ee;
    color: #fff;
  }

  ul.serviceFilter li:hover {
    cursor: pointer;
  }

  .stats {
    padding: 2em;

    .title {
      font-size: 1.6em;
    }
  }

  .Box {

    .table {
      background: none;

      th {
        font-size: 1.2rem;
      }

      th,
      td {
        color: #fff;
      }
    }

    &.Economy {
      background: #3b61da;
    }

    &.Community {
      background: #e27933;
    }

    &.Environment {
      background: #29a358;
    }

    &.Placemaking {
      background: #e7b128;
    }

    &.Leadership {
      background: #794fa0;
    }

    .title {
      color: #fff;
      padding: .5rem;
    }

    ul {
      list-style: square;
      list-style-position: inside;
      padding-left: 1rem;

      li {
        color: #fff;
      }
    }

    .indicator {
      color: #fff;
      padding-left: .5rem;
    }

  }

  .circle {
    width: 110px;
    height: 110px;
    border-radius: 200px;
    // border: 1px solid #333;
    background: #333;
    color: #eee;
    text-align: center;
    padding: 1.2em;
    display: inline-block;
    margin-right: -1em;
    margin-bottom: 0.6em;

    &.Economy {
      background: #3b61da;
      border: 1px solid darken(#3b61da, 10%);
    }

    &.Community {
      background: #e27933;
      border: 1px solid darken(#e27933, 10%);
    }

    &.Environment {
      background: #29a358;
      border: 1px solid darken(#29a358, 10%);
    }

    &.Placemaking {
      background: #e7b128;
      border: 1px solid darken(#e7b128, 10%);
    }

    &.Leadership {
      background: #794fa0;
      border: 1px solid darken(#794fa0, 10%);
    }

    .year {
      font-weight: 800;
      color: #eee;
    }

    .value {
      font-size: 3em;
      font-weight: 900;
      line-height: 0.8em;
      letter-spacing: -0.1em;
      color: #eee;
    }
  }
</style>


// WEBPACK FOOTER //
// Modules/CityPlan/Resources/assets/js/components/CityPlanReview.vue